import React from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import { Form, Field } from "react-final-form";
import arrayMutators from "final-form-arrays";
import * as FormUtils from "common/FormUtils";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import CheckboxPack from "components/CheckboxPack";
import SelectPack from "components/SelectPack2";
import InputPack from "components/InputPack";
import BlockSelector from "components/new/BlockSelector";
import MonthSelector from "./MonthSelector";
import { closeModal } from "containers/App/_actions";

class OutdoorPigLiquidApplicationModal extends React.Component {
    validate = (viewModel) => {
        const error = {};

        error.applicationDepth = FormUtils.validators.required(viewModel.applicationDepth);

        const showArea = this.doSelectedBlocksRequireArea(viewModel.availableBlocks, viewModel.blockIds);
        if (showArea) {
            error.areaEffluent = FormUtils.validators.required(viewModel.areaEffluent);
            error.areaEffluent = error.areaEffluent || FormUtils.validators.range(1, 100)(viewModel.areaEffluent);
        }

        return error;
    };

    doSelectedBlocksRequireMonths = (blocks, selectedBlockIds) => {
        const blockIdsRequiringMonths = (blocks || []).filter((b) => ["ProductiveCrop", "FodderCrop"].includes(b.type)).map((b) => b.id);
        return (selectedBlockIds || []).some((blockId) => blockIdsRequiringMonths.some((id) => id === blockId));
    };

    doSelectedBlocksRequireArea = (blocks, selectedBlockIds) => {
        const blockIdsRequiringArea = (blocks || []).filter((b) => ["ProductivePasture"].includes(b.type) && b.runoffCharacteristics).map((b) => b.id);
        return (selectedBlockIds || []).some((blockId) => blockIdsRequiringArea.some((id) => id === blockId));
    };

    submit = (viewModel) => {
        delete viewModel.availableBlocks;
        this.props.modal.onConfirm(viewModel);
        this.props.closeModal();
    };

    render() {
        const { viewModel, refData } = this.props;

        return (
            <Form initialValues={viewModel} mutators={{ ...arrayMutators }} validate={this.validate} onSubmit={this.submit}>
                {({ form, values, handleSubmit, submitting, submitSucceeded }) => {
                    const disableSave = submitSucceeded || submitting;
                    const showMonths = viewModel.monthsAreRequired || this.doSelectedBlocksRequireMonths(viewModel.availableBlocks, values.blockIds);
                    const showArea = this.doSelectedBlocksRequireArea(viewModel.availableBlocks, values.blockIds);

                    return (
                        <Modal title="Liquid effluent application" allowOffline={true}>
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        <Grid>
                                            <Field name="id" type="hidden" component="input" />
                                            <GridCell className="u-width4of5">
                                                <Field name="blockIds" availableBlocks={viewModel.availableBlocks} component={BlockSelector} />
                                            </GridCell>
                                        </Grid>
                                        <Grid title="Application">
                                            <GridCell className="u-width1of3">
                                                <Field name="applicationDepth" label="Application depth" placeholder="Select an application depth" required options={refData.effluentAppRates} component={SelectPack} />
                                            </GridCell>
                                            {showArea && (
                                                <GridCell className="u-width1of3">
                                                    <Field name="areaEffluent" label="Percentage of block area" uom="%" placeholder="0" required type="text" component={InputPack} format={FormUtils.formatters.formatInt} formatOnBlur />
                                                </GridCell>
                                            )}
                                            <GridCell>
                                                <Field name="activeManagement" type="Checkbox" component={CheckboxPack} label="Actively managed" />
                                            </GridCell>
                                        </Grid>
                                        {showMonths && (
                                            <Grid title="Months">
                                                <GridCell>
                                                    <MonthSelector form={form} monthsFieldName="months" />
                                                </GridCell>
                                            </Grid>
                                        )}
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="save-button" type="submit" className="Button" disabled={disableSave}>
                                                    Done
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}
export default compose(withAppContext, withActions({ closeModal }))(OutdoorPigLiquidApplicationModal);
